import { parseJSON } from "../../utils/helperUtils";
import { forIn, keys, omit } from "lodash";
import moment from "moment";
import { DEFAULT_DATE_FORMAT } from "../../utils/formattingUtils";
import { EventTile } from "./EventTile";
import { StatusEnum } from "../../endpoints/getArtifacts";
import { Space } from "../space/Space";

export const now = new Date().toISOString();

export const getTwoMonthsBack = date =>
    moment(date).subtract(2, "month").startOf("month").format(DEFAULT_DATE_FORMAT);

export const getTwoMonthsAhead = date =>
    moment(date).add(2, "month").startOf("month").format(DEFAULT_DATE_FORMAT);

export const renderEvents = (dateToRender, calendarEvents, setCalendarTableQuery) => {
    let isMatch = false;
    let dateKey = "";
    forIn(calendarEvents, (_, eventDate) => {
        const currentDate = moment(eventDate);
        const renderDate = moment(dateToRender.date);
        if (currentDate.format("MM/DD/YYY") === renderDate.format("MM/DD/YYY")) {
            dateKey = eventDate;
            isMatch = true;
        }
    });

    return isMatch ? (
        <>
            {Object.entries(omit(calendarEvents[dateKey], ["docCount"])).map(
                (event: [string, any]) => {
                    const documentTypeEvent = parseJSON(event[1]);

                    return (
                        <>
                            {keys(parseJSON(event[1])).map(statusType => {
                                switch (statusType) {
                                    case "OPEN": {
                                        return (
                                            <EventTile
                                                message={`${documentTypeEvent?.OPEN?.docCount} open`}
                                                accent={
                                                    moment(dateKey).format("MM/DD/YYYY") ===
                                                    moment().format("MM/DD/YYYY")
                                                        ? "warning"
                                                        : "success"
                                                }
                                                date={dateKey}
                                                status={StatusEnum.OPEN}
                                                documentType={event[0]}
                                                documentTypeCount={event[1]?.docCount}
                                                setCalendarTableQuery={setCalendarTableQuery}
                                            />
                                        );
                                    }
                                    case "CLOSED": {
                                        return (
                                            <EventTile
                                                message={`${isAllClosed(event[1]?.docCount, documentTypeEvent?.CLOSED?.docCount)} closed`}
                                                accent={"neutral"}
                                                date={dateKey}
                                                status={StatusEnum.CLOSED}
                                                documentType={event[0]}
                                                documentTypeCount={event[1]?.docCount}
                                                setCalendarTableQuery={setCalendarTableQuery}
                                            />
                                        );
                                    }
                                    case "UNREAD": {
                                        return (
                                            <EventTile
                                                message={`${documentTypeEvent?.UNREAD?.docCount} unread`}
                                                accent={"theme"}
                                                date={dateKey}
                                                status={StatusEnum.UNREAD}
                                                documentType={event[0]}
                                                documentTypeCount={event[1]?.docCount}
                                                setCalendarTableQuery={setCalendarTableQuery}
                                            />
                                        );
                                    }
                                    case "OVERDUE": {
                                        return (
                                            <EventTile
                                                message={`${documentTypeEvent?.OVERDUE?.docCount} overdue`}
                                                accent={"error"}
                                                date={dateKey}
                                                status={StatusEnum.OVERDUE}
                                                documentType={event[0]}
                                                documentTypeCount={event[1]?.docCount}
                                                setCalendarTableQuery={setCalendarTableQuery}
                                            />
                                        );
                                    }
                                }
                            })}
                            <Space size={"xxs"} />
                        </>
                    );
                }
            )}
        </>
    ) : null;
};

const isAllClosed = (documentTypeCount, statusTypeCount) => {
    return documentTypeCount === statusTypeCount ? "All" : statusTypeCount;
};
